import { render, staticRenderFns } from "./author-view-desc.vue?vue&type=template&id=237849e9&"
import script from "./author-view-desc.vue?vue&type=script&lang=js&"
export * from "./author-view-desc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports